import { useRef } from 'react'

import { Wrapper } from './styles'
import { ModalProps } from './types'

const Modal = ({ position = 'center', children, onHide }: ModalProps) => {
  const modalRef = useRef<HTMLDivElement>(null)

  return (
    <Wrapper
      onClick={e => e.target === modalRef.current && onHide(e)}
      ref={modalRef}
      position={position}
    >
      {children}
    </Wrapper>
  )
}

export default Modal
